<router-outlet></router-outlet>
<!--<div class="vitaleDigital">-->
<!--  Vitale Digital - v1.{{time}}-->
<!--</div>-->
